"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.navbarReset = exports.navToggle = void 0;
/* ========================================================================
    Module: Navbar
 ========================================================================== */
const uikit_1 = __importDefault(require("uikit"));
const navbarActiveClass = "is-active";
const toggleActiveClass = "is-active";
const navbarElement = document.querySelector(".js-navbar");
const navToggleElement = document.querySelector(".js-nav-toggle");
const breakpointLarge = uikit_1.default.util.getCssVar("breakpoint-l");
let focusedElementBefore;
let firstTabStop;
let lastTabStop;
/**
 * ナビゲーションを表示・非表示する
 *
 * @param {MouseEvent | KeyboardEvent} e
 * @returns void
 */
const navToggle = (e) => {
    if (e instanceof KeyboardEvent && e.type === "keydown") {
        const key = keyboardEventKey(e);
        // Check for ENTER key press
        if (key !== 13 && key !== "Enter") {
            return;
        }
        else {
            e.preventDefault();
        }
    }
    focusedElementBefore = document.activeElement;
    if (navbarElement) {
        navbarElement.addEventListener("keydown", { handleEvent: trapTabKey });
        // Find all focusable children
        const focusableElementsString = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex="0"], [tabindex="-1"], [contenteditable]';
        let focusableElements = navbarElement.querySelectorAll(focusableElementsString);
        // Convert NodeList to Array
        focusableElements = Array.prototype.slice.call(focusableElements);
        firstTabStop = focusableElements[0];
        lastTabStop = focusableElements[focusableElements.length - 1];
    }
    navbarElement?.classList.toggle(navbarActiveClass);
    if (navToggleElement?.classList.contains(toggleActiveClass)) {
        scrollEnable();
        navbarElement?.setAttribute("aria-hidden", "true");
    }
    else {
        scrollDisable();
        navbarElement?.setAttribute("aria-hidden", "false");
        navbarElement.focus();
    }
    navToggleElement?.classList.toggle(toggleActiveClass);
};
exports.navToggle = navToggle;
/**
 * ナビゲーションの状態をリセットする
 *
 * @returns void
 */
const navbarReset = () => {
    if (window.matchMedia(`(min-width: ${breakpointLarge})`).matches) {
        scrollEnable();
        navbarElement?.setAttribute("aria-hidden", "false");
        navbarElement?.classList.remove(navbarActiveClass);
        navToggleElement?.classList.remove(toggleActiveClass);
        if (navbarElement) {
            navbarElement.blur();
        }
    }
};
exports.navbarReset = navbarReset;
/**
 * タブキーでのフォーカスを navbar 内に限定する
 *
 * @param {KeyboardEvent} e
 * @returns void
 */
function trapTabKey(e) {
    if (e.defaultPrevented) {
        return;
    }
    const key = keyboardEventKey(e);
    // Check for TAB key press
    if (key === 9 || key === "Tab") {
        // SHIFT + TAB
        if (e.shiftKey) {
            if (document.activeElement === firstTabStop) {
                e.preventDefault();
                lastTabStop.focus();
            }
            // TAB
        }
        else {
            if (document.activeElement === lastTabStop) {
                e.preventDefault();
                firstTabStop.focus();
            }
        }
    }
    // ESCAPE
    if (key === 27 || key === "Escape") {
        scrollEnable();
        navbarElement?.setAttribute("aria-hidden", "false");
        navbarElement?.classList.remove(navbarActiveClass);
        navToggleElement?.classList.remove(toggleActiveClass);
        if (focusedElementBefore) {
            focusedElementBefore.focus();
        }
    }
}
/**
 * 背後のコンテンツスクロールを無効にする
 *
 * @returns void
 */
function scrollDisable() {
    if (window.innerWidth - document.body.clientWidth) {
        document.body.style.overflowY = "scroll";
    }
    document.documentElement.style.overflow = "hidden";
}
/**
 * 背後のコンテンツスクロールを有効にする
 *
 * @returns void
 */
function scrollEnable() {
    document.body.style.overflowY = "";
    document.documentElement.style.overflow = "";
}
/**
 * キーボードイベントのキーを返す
 *
 * @param {KeyboardEvent} e
 * @returns string | number
 */
function keyboardEventKey(e) {
    let key = "";
    if (e.key !== undefined) {
        key = e.key;
    }
    else if (e.keyCode !== undefined) {
        key = e.keyCode;
    }
    return key;
}
